import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../../components/shareableContainer/ConfirmationModal";
import PropertyStepProgress from "../../../../components/common/PropertyStepProgress";
import CustomButton from "../../../../components/common/CustomButton";
import CustomHeading from "../../../../components/common/CustomHeading";
import Header from "../../../Header/Header";
import { ToastContainer } from "react-toastify";
import { showErrorToast, showSuccessToast } from "../../../../components/Constant/Notification";
import { userUid } from "../../../../utils/storage";
import ProspectPropertyService from "../../../Service/ProspectPropertyService";
import { formatDate, formatToIndianDate, formatDateValue, formatDateForInput } from "../../../../utils/dateFormatter";
import ProspectPropertyInfoBasic from "../ProspectPropertyInfoBasic";
import ProspectLayoutUnitPage from "./ProspectLayoutUnitPage";
import CustomModal from "../../../../components/common/CustomModel";
import UserService from "../../../../GlobalSetupComponents/Services/UserService";
import { backendProcurementHeadRoles } from "../../../../GlobalSetupComponents/Enum/RoleEnum";
import CustomSelect from "../../../../components/common/CustomSelect";
import { availableId } from "../../../../Enum";

const ProspectLayoutPage = () => {
  const location = useLocation();
  const { propertyId, selectedPropertyDetails, propertySaleType, propertyTypeName, propertyName, propertyStage } = location.state || { propertyId: null };
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [createdPropertyId, setCreatedPropertyId] = useState(propertyId || null);
  const navigate = useNavigate();
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [selectedAssignUser, setSelectedAssignUser] = useState(null);
  const [isAssignLoading, setIsAssignLoading] = useState(false);
  const [sourceBy, setSourceBy] = useState([]);

  const [propertyInfo, setPropertyInfo] = useState({
    name: "",
    propertyId: "",
    propertyEnteredDate: "",
    noOfUnits: "",
    location: null,
    village: null,
    locationLatitude: null,
    locationLongitude: null,
    address: "",
    landmark: "",
    link: "",
    docReceivedOrNot: false,
    docReceivedDate: "",
    fullSetOfDocReceivedDate: "",
    marketingRatePer: "",
    marketingRatePerValue: "",
    vendorRatePer: "",
    vendorRatePerValue: "",
    commissionType: "",
    commissionValue: "",
    loanOrCashMinCalculateBy: "",
    loanOrCashMaxCalculateBy: "",
    loanMaxValue: "",
    loanMinValue: "",
    cashMaxValue: "",
    cashMinValue: "",
    primarySourcedBy: "",
    secondarySourcedBy: "",
    vendorName: "",
    vendorPhoneNumber: "",
    mediatorName: "",
    mediatorPhoneNumber: "",
    traderName: "",
    traderPhoneNumber: "",
    advanceAmount: "",
    propertyTimeDuration: "",
    propertyTimeDurationStartDate: "",
    propertyTimeDurationEndDate: "",
    advanceAmountPaidTo: "",
    seenOriginalDocOrNot: false,
    metOwnerOrNot: false,
    sittingPlace: "",
    images: [],
    driveLink: "",
    sketchLink: "",
    attachedLink: "",
    notes: "",
    propertyType: selectedPropertyDetails?.id || "",
    propertyTypeName: selectedPropertyDetails?.label || "",
    propertySaleType: propertySaleType || "",
    stage: propertyStage || "",
    locationLink: "",
    vendorCountryCode: "",
    mediatorCountryCode: "",
    traderCountryCode: "",
    overAllAreaSqft: "",
    overAllAreaCent: "",
    overAllAreaGround: "",
    overAllAreaAcres: "",
    geoLocation: "",
    createdById: userUid || "",
  });

  const [units, setUnits] = useState([]);
  const [unitTotal, setUnitTotal] = useState(0);

  const formatINR = (value) => {
    return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(value);
  };

  const formatINRShort = (value) => {
    if (value >= 10000000) return (value / 10000000).toFixed(2) + " Cr";
    if (value >= 100000) return (value / 100000).toFixed(2) + " L";
    if (value >= 1000) return (value / 1000).toFixed(2) + " K";
    return value.toString();
  };

  useEffect(() => {
    const fetchUserRoleBasedData = async () => {
      try {
        const body = { roleIds: backendProcurementHeadRoles };
        const response = await UserService.getUserRoleBasedNames(body);
        const data = response.data?.users || [];
        setSourceBy(data);
      } catch (error) {
        showErrorToast("Failed to fetch user role-based data");
      }
    };
    fetchUserRoleBasedData();
  }, []);

  const getStatusStyles = (status) => {
    switch (status?.toLowerCase()) {
      case "available": return "text-green-600";
      case "sold": return "text-red-600";
      case "booked": return "text-yellow-600";
      default: return "text-gray-600";
    }
  };

  // const handlePropertyInfoChange = (e) => {
  //   const { name, value } = e.target;
  //   setPropertyInfo((prev) => {
  //     const updated = { ...prev, [name]: value };
  //     if (name === "geoLocation") {
  //       const coords = value.split(",").map((c) => c.trim());
  //       updated.locationLink = coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1]) ? `https://www.google.com/maps?q=${coords[0]},${coords[1]}` : "";
  //       updated.locationLatitude = coords[0] ? Number(coords[0]) : null;
  //       updated.locationLongitude = coords[1] ? Number(coords[1]) : null;
  //     }
  //     return updated;
  //   });
  // };

    const handlePropertyInfoChange = (e) => {
    const { name, value } = e.target;
    setPropertyInfo((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "geoLocation") {
        const coords = value.split(",").map((c) => c.trim());
        updated.locationLink =
          coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])
            ? `https://www.google.com/maps?q=${coords[0]},${coords[1]}`
            : "";
      }
      return updated;
    });
  };


  const handleArrayFieldChange = (fieldName, values) => {
    setPropertyInfo((prev) => ({ ...prev, [fieldName]: values }));
  };

  const handleAddUnit = useCallback((unit) => {
    // Generate a unique local identifier for new units
    const localId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    
    const newUnit = {
      ...unit,
      id: null, // Explicitly set to null for new units
      localId: localId, // Add local identifier for tracking
      order: units.length + 1,
      isLocallyCreated: true, // Mark as locally created
    };
    
    console.log("Adding new unit to local state:", newUnit);
    setUnits((prev) => [...prev, newUnit]);
  }, [units]);

  const handleEditUnit = useCallback((updatedUnit) => {
    console.log("Editing unit:", updatedUnit);
    console.log("Current units:", units);
    
    setUnits((prev) => {
      const updatedUnits = prev.map((unit) => {
        // First priority: match by real ID
        if (unit.id && updatedUnit.originalId && unit.id === updatedUnit.originalId) {
          console.log("Matched by real ID:", unit.id);
          return { ...updatedUnit, id: unit.id, isLocallyCreated: false };
        }
        // Second priority: match by localId
        else if (unit.localId && updatedUnit.originalLocalId && unit.localId === updatedUnit.originalLocalId) {
          console.log("Matched by localId:", unit.localId);
          return { ...updatedUnit, localId: unit.localId, isLocallyCreated: true };
        }
        // Third priority: match by current localId if it exists
        else if (unit.localId && updatedUnit.localId && unit.localId === updatedUnit.localId) {
          console.log("Matched by current localId:", unit.localId);
          return { ...updatedUnit, isLocallyCreated: true };
        }
        // Fourth priority: match by current ID
        else if (unit.id && updatedUnit.id && unit.id === updatedUnit.id) {
          console.log("Matched by current ID:", unit.id);
          return { ...updatedUnit, isLocallyCreated: false };
        }
        
        return unit;
      });
      
      console.log("Updated units:", updatedUnits);
      return updatedUnits;
    });
  }, [units]);

  const fetchGetPropertyById = useCallback(async (id) => {
    try {
      setLoading(true);
      const response = await ProspectPropertyService.getProspectPropertyId(id);
      if (response.status === 200) {
        const data = response.data || {};
        let geoLocationValue = "";
        if (data.locationLatitude && data.locationLongitude) {
          geoLocationValue = `${data.locationLatitude}, ${data.locationLongitude}`;
        } else if (data.link) {
          const coordsMatch = data.link.match(/q=(-?\d+\.?\d*),(-?\d+\.?\d*)/);
          if (coordsMatch) {
            geoLocationValue = `${coordsMatch[1]}, ${coordsMatch[2]}`;
          }
        }

        setPropertyInfo((prev) => ({
          ...prev,
          name: data.name || "",
          propertyId: data.propertyId || "",
          propertyEnteredDate: formatDateValue(data.propertyEnteredDate) || "",
          noOfUnits: data.noOfUnits || "",
          location: data.location ? { value: data.location.id, label: data.location.name } : null,
          village: data.village ? { value: data.village.id, label: data.village.name } : null,
          locationLatitude: data.locationLatitude || null,
          locationLongitude: data.locationLongitude || null,
          address: data.address || "",
          landmark: data.landmark || "",
          link: data.link || "",
          docReceivedOrNot: data.docReceivedOrNot || false,
          docReceivedDate: formatDateValue(data.docReceivedDate) || "",
          fullSetOfDocReceivedDate: formatDateValue(data.fullSetOfDocReceivedDate) || "",
          marketingRatePer: data.marketingRatePer || "",
          marketingRatePerValue: data.marketingRatePerValue || "",
          vendorRatePer: data.vendorRatePer || "",
          vendorRatePerValue: data.vendorRatePerValue || "",
          commissionType: data.commissionType || "",
          commissionValue: data.commissionValue || "",
          loanOrCashMinCalculateBy: data.loanOrCashMinCalculateBy || "",
          loanOrCashMaxCalculateBy: data.loanOrCashMaxCalculateBy || "",
          loanMaxValue: data.loanMaxValue || "",
          loanMinValue: data.loanMinValue || "",
          cashMaxValue: data.cashMaxValue || "",
          cashMinValue: data.cashMinValue || "",
          primarySourcedBy: data.primarySourcedBy?.id || "",
          secondarySourcedBy: data.secondarySourcedBy?.id || "",
          vendorName: data.vendorName || "",
          vendorPhoneNumber: data.vendorPhoneNumber || "",
          mediatorName: data.mediatorName || "",
          mediatorPhoneNumber: data.mediatorPhoneNumber || "",
          traderName: data.traderName || "",
          traderPhoneNumber: data.traderPhoneNumber || "",
          advanceAmount: data.advanceAmount || "",
          propertyTimeDuration: data.propertyTimeDuration || "",
          propertyTimeDurationStartDate: formatDateValue(data.propertyTimeDurationStartDate) || "",
          propertyTimeDurationEndDate: formatDateValue(data.propertyTimeDurationEndDate) || "",
          advanceAmountPaidTo: data.advanceAmountPaidTo || "",
          seenOriginalDocOrNot: data.seenOriginalDocOrNot || false,
          metOwnerOrNot: data.metOwnerOrNot || false,
          sittingPlace: data.sittingPlace || "",
          images: data.images || [],
          driveLink: data.driveLink || "",
          sketchLink: data.sketchLink || "",
          attachedLink: data.attachedLink || "",
          notes: data.notes || "",
          propertyType: data.propertyType?.id || "",
          propertyTypeName: data.propertyType?.name || "",
          propertySaleType: data.propertySaleType?.name || "",
          stage: data.stage || "",
          locationLink: data.locationLink || "",
          vendorCountryCode: data.vendorCountryCode || "",
          mediatorCountryCode: data.mediatorCountryCode || "",
          traderCountryCode: data.traderCountryCode || "",
          overAllAreaSqft: data.overAllAreaSqft || "",
          overAllAreaCent: data.overAllAreaCent || "",
          overAllAreaGround: data.overAllAreaGround || "",
          overAllAreaAcres: data.overAllAreaAcres || "",
          geoLocation: geoLocationValue,
          createdById: data.createdById || userUid || "",

        }));
        setSelectedAssignUser(data.assignedBackendUser ? { value: data.assignedBackendUser.id, label: data.assignedBackendUser.name } : null);  
        setUnits(data.units || []);
      }
    } catch (error) {
      console.error("Error fetching property data:", error);
      showErrorToast("Failed to fetch property data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchGetUnitsByPropertyId = useCallback(async (id) => {
    try {
      setLoading(true);
      const body = { propertyId: id, propertyType: propertyTypeName || selectedPropertyDetails?.label || "" };
      const response = await ProspectPropertyService.getUnitsByPropertyId(body);
      const data = response.data?.data || [];
      setUnits(data?.units || []);
      setUnitTotal(data.totalUnits || 0);
    } catch (error) {
      console.error("Error fetching units data:", error);
      showErrorToast("Failed to fetch units data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [propertyTypeName]);

  useEffect(() => {
    if (propertyId) {
      fetchGetPropertyById(propertyId);
    }
  }, [propertyId, fetchGetPropertyById]);

  useEffect(() => {
    if (propertyId && currentStep === 2) {
      fetchGetUnitsByPropertyId(propertyId);
    }
  }, [propertyId, currentStep, fetchGetUnitsByPropertyId]);

  // Helper function to format dates for API payload
  const formatDateForAPI = (dateStr) => {
    if (!dateStr) return null;
    try {
      // If already in DD-MM-YYYY format, convert to YYYY-MM-DD
      if (typeof dateStr === 'string' && dateStr.includes('-')) {
        const parts = dateStr.split('-');
        if (parts.length === 3 && parts[0].length <= 2) {
          // DD-MM-YYYY format
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        } else if (parts.length === 3 && parts[0].length === 4) {
          // Already YYYY-MM-DD format
          return dateStr;
        }
      }
      // Try to parse as Date and format
      const date = new Date(dateStr);
      if (!isNaN(date.getTime())) {
        return date.toISOString().split('T')[0];
      }
      return null;
    } catch (error) {
      console.warn('Date formatting error:', error);
      return null;
    }
  };

  // const createPayload = useCallback(() => {
  //   return {
  //     name: propertyInfo.name || null,
  //     propertyId: propertyInfo.propertyId || null,
  //     propertyEnteredDate: formatDateForAPI(propertyInfo.propertyEnteredDate),
  //     noOfUnits: parseInt(propertyInfo.noOfUnits) || units.length || 0,
  //     location: propertyInfo.location?.value || null,
  //     village: propertyInfo.village?.value || null,
  //    locationLatitude: propertyInfo.geoLocation
  //       ? Number(propertyInfo.geoLocation.split(",")[0].trim())
  //       : propertyInfo.locationLatitude || null,
  //     locationLongitude: propertyInfo.geoLocation
  //       ? Number(propertyInfo.geoLocation.split(",")[1].trim())
  //       : propertyInfo.locationLongitude || null,
  //     address: propertyInfo.address || null,
  //     landmark: propertyInfo.landmark || null,
  //     link: propertyInfo.link || null,
  //     docReceivedOrNot: Boolean(propertyInfo.docReceivedOrNot),
  //     docReceivedDate: formatDateForAPI(propertyInfo.docReceivedDate),
  //     fullSetOfDocReceivedDate: formatDateForAPI(propertyInfo.fullSetOfDocReceivedDate),
  //     marketingRatePer: propertyInfo.marketingRatePer || null,
  //     marketingRatePerValue: Number(propertyInfo.marketingRatePerValue )|| null,
  //     vendorRatePer: propertyInfo.vendorRatePer || null,
  //     vendorRatePerValue: Number(propertyInfo.vendorRatePerValue) || null,
  //     commissionType: propertyInfo.commissionType || null,
  //     commissionValue: propertyInfo.commissionValue || null,
  //     loanOrCashMinCalculateBy: propertyInfo.loanOrCashMinCalculateBy || null,
  //     loanOrCashMaxCalculateBy: propertyInfo.loanOrCashMaxCalculateBy || null,
  //     loanOrCashMaxValue: propertyInfo.loanOrCashMaxValue || null,
  //     loanOrCashMinValue: propertyInfo.loanOrCashMinValue || null,
  //     primarySourcedBy: propertyInfo.primarySourcedBy || null,
  //     secondarySourcedBy: propertyInfo.secondarySourcedBy || null,
  //     vendorName: propertyInfo.vendorName || null,
  //     vendorPhoneNumber: propertyInfo.vendorPhoneNumber || null,
  //     mediatorName: propertyInfo.mediatorName || null,
  //     mediatorPhoneNumber: propertyInfo.mediatorPhoneNumber || null,
  //     traderName: propertyInfo.traderName || null,
  //     traderPhoneNumber: propertyInfo.traderPhoneNumber || null,
  //     advanceAmount: Number(propertyInfo.advanceAmount) || null,
  //     propertyTimeDuration: propertyInfo.propertyTimeDuration || null,
  //     propertyTimeDurationStartDate: formatDateForAPI(propertyInfo.propertyTimeDurationStartDate),
  //     propertyTimeDurationEndDate: formatDateForAPI(propertyInfo.propertyTimeDurationEndDate),
  //     advanceAmountPaidTo: propertyInfo.advanceAmountPaidTo || null,
  //     seenOriginalDocOrNot: Boolean(propertyInfo.seenOriginalDocOrNot),
  //     metOwnerOrNot: Boolean(propertyInfo.metOwnerOrNot),
  //     sittingPlace: propertyInfo.sittingPlace || null,
  //     images: propertyInfo.images || [],
  //     driveLink: propertyInfo.driveLink || null,
  //     sketchLink: propertyInfo.sketchLink || null,
  //     attachedLink: propertyInfo.attachedLink || null,
  //     notes: propertyInfo.notes || null,
  //     propertyType: propertyInfo.propertyType || null,
  //     propertySaleType: propertyInfo.propertySaleType || null,
  //     stage: propertyInfo.stage || null,
  //     locationLink: propertyInfo.locationLink || null,
  //     vendorCountryCode: propertyInfo.vendorCountryCode || "",
  //     mediatorCountryCode: propertyInfo.mediatorCountryCode || "",
  //     traderCountryCode: propertyInfo.traderCountryCode || "",
  //     overAllAreaSqft: Number(propertyInfo.overAllAreaSqft) || null,
  //     overAllAreaCent: Number(propertyInfo.overAllAreaCent) || null,
  //     overAllAreaGround: Number(propertyInfo.overAllAreaGround) || null,
  //     overAllAreaAcres: Number(propertyInfo.overAllAreaAcres) || null,
  //     createdById: userUid || null,
  //     assignedBackendUser: selectedAssignUser?.value || null,
  //   };
  // }, [propertyInfo, units, selectedAssignUser]);

  const createPayload = useCallback(() => {
  return {
    name: propertyInfo.name || null,
    propertyId: propertyInfo.propertyId || null,

    // Timestamp fields
    propertyEnteredDate: formatDate(propertyInfo.propertyEnteredDate),
    docReceivedDate: formatDate(propertyInfo.docReceivedDate),
    fullSetOfDocReceivedDate: formatDate(propertyInfo.fullSetOfDocReceivedDate),
    propertyTimeDurationStartDate: formatDate(propertyInfo.propertyTimeDurationStartDate),
    propertyTimeDurationEndDate: formatDate(propertyInfo.propertyTimeDurationEndDate),

    // Number fields
    noOfUnits: Number(propertyInfo.noOfUnits) || units.length || 0,
    locationLatitude: propertyInfo.geoLocation
      ? Number(propertyInfo.geoLocation.split(",")[0].trim())
      : Number(propertyInfo.locationLatitude) || null,
    locationLongitude: propertyInfo.geoLocation
      ? Number(propertyInfo.geoLocation.split(",")[1].trim())
      : Number(propertyInfo.locationLongitude) || null,
    marketingRatePerValue: Number(propertyInfo.marketingRatePerValue) || null,
    vendorRatePerValue: Number(propertyInfo.vendorRatePerValue) || null,
    commissionValue: Number(propertyInfo.commissionValue) || null,
    loanMinValue: Number(propertyInfo.loanMinValue) || null,
    loanMaxValue: Number(propertyInfo.loanMaxValue) || null,
    cashMinValue: Number(propertyInfo.cashMinValue) || null,
    cashMaxValue: Number(propertyInfo.cashMaxValue) || null,
    advanceAmount: Number(propertyInfo.advanceAmount) || null,
    overAllAreaSqft: Number(propertyInfo.overAllAreaSqft) || null,
    overAllAreaCent: Number(propertyInfo.overAllAreaCent) || null,
    overAllAreaGround: Number(propertyInfo.overAllAreaGround) || null,
    overAllAreaAcres: Number(propertyInfo.overAllAreaAcres) || null,

    // DocumentReference fields
    location: propertyInfo.location?.value || null,
    village: propertyInfo.village?.value || null,
    primarySourcedBy: propertyInfo.primarySourcedBy || null,
    secondarySourcedBy: propertyInfo.secondarySourcedBy || null,
    propertyType: propertyInfo.propertyType || null,
    propertySaleType: propertyInfo.propertySaleType || null,
    assignedBackendUser: selectedAssignUser?.value || null,

    // Boolean fields
    docReceivedOrNot: Boolean(propertyInfo.docReceivedOrNot),
    seenOriginalDocOrNot: Boolean(propertyInfo.seenOriginalDocOrNot),
    metOwnerOrNot: Boolean(propertyInfo.metOwnerOrNot),

    // String fields
    address: propertyInfo.address || null,
    landmark: propertyInfo.landmark || null,
    link: propertyInfo.link || null,
    marketingRatePer: propertyInfo.marketingRatePer || null,
    vendorRatePer: propertyInfo.vendorRatePer || null,
    commissionType: propertyInfo.commissionType || null,
    loanOrCashMinCalculateBy: propertyInfo.loanOrCashMinCalculateBy || null,
    loanOrCashMaxCalculateBy: propertyInfo.loanOrCashMaxCalculateBy || null,
    vendorName: propertyInfo.vendorName || null,
    vendorPhoneNumber: propertyInfo.vendorPhoneNumber || null,
    mediatorName: propertyInfo.mediatorName || null,
    mediatorPhoneNumber: propertyInfo.mediatorPhoneNumber || null,
    traderName: propertyInfo.traderName || null,
    traderPhoneNumber: propertyInfo.traderPhoneNumber || null,
    propertyTimeDuration: propertyInfo.propertyTimeDuration || null,
    advanceAmountPaidTo: propertyInfo.advanceAmountPaidTo || null,
    sittingPlace: propertyInfo.sittingPlace || null,
    driveLink: propertyInfo.driveLink || null,
    sketchLink: propertyInfo.sketchLink || null,
    attachedLink: propertyInfo.attachedLink || null,
    notes: propertyInfo.notes || null,
    stage: propertyInfo.stage || null,
    locationLink: propertyInfo.locationLink || null,

    // Default country codes
          vendorCountryCode: propertyInfo.vendorPhoneNumber ? propertyInfo.vendorCountryCode : null || null,
      mediatorCountryCode: propertyInfo.mediatorPhoneNumber ? propertyInfo.mediatorCountryCode : null || null,
      traderCountryCode: propertyInfo.traderPhoneNumber ? propertyInfo.traderCountryCode : null || null,
    // List fields
    images: propertyInfo.images || [],
    searchKey: propertyInfo.searchKey || [],

    // Audit fields
    createdById: userUid || null,
  };
}, [propertyInfo, units, selectedAssignUser]);

  const handleSaveOrUpdateProperty = async () => {
    setLoading(true);
    const payload = createPayload();
    try {
      let response;
      if (createdPropertyId) {
        const updatedPayload = { ...payload, modifiedById: userUid || null };
        response = await ProspectPropertyService.updateProspectProperty(createdPropertyId, updatedPayload);
      } else {
        response = await ProspectPropertyService.createProspectProperty(payload);
      }
      if (response.status === 200 || response.status === 201) {
        const newPropertyId = response.data?.id || response.data?.data?.id || createdPropertyId;
        if (!createdPropertyId && newPropertyId) {
          setCreatedPropertyId(newPropertyId);
        }
        showSuccessToast(createdPropertyId ? "Property updated successfully!" : response.data?.message || "Property created successfully!");
        if (currentStep === 1) {
          setCurrentStep(2);
        }
      }
    } catch (error) {
      console.error(`Error ${createdPropertyId ? "updating" : "saving"} property:`, error);
      showErrorToast(error.response?.data?.message || `Failed to ${createdPropertyId ? "update" : "save"} property. Please try again.`);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveUnits = async () => {
    if (!createdPropertyId) {
      showErrorToast("Please save the property first");
      return;
    }

    if (units.length === 0) {
      showErrorToast("Please add at least one unit");
      return;
    }

    setLoading(true);
    try {
      const newUnits = units.filter((unit) => !unit.id || unit.id === null);
      const existingUnits = units.filter((unit) => unit.id && unit.id !== null);
      let newUnitsSaved = false;
      let existingUnitsUpdated = false;

      if (newUnits.length > 0) {
        const createUnitsPayload = {
          propertyId: createdPropertyId,
          propertyType: propertyTypeName || selectedPropertyDetails?.label,
          unitsData: newUnits.map((unit, index) => ({
            order: unit.order || index + 1,
            unitNo: unit.unitNo?.trim() || null,
            sqft: unit.sqft && Number(unit.sqft) > 0 ? Number(unit.sqft) : null,
            ratePerSqft: unit.ratePerSqft && Number(unit.ratePerSqft) > 0 ? Number(unit.ratePerSqft) : null,
            governmentGuideline: unit.governmentGuideline && Number(unit.governmentGuideline) > 0 ? Number(unit.governmentGuideline) : null,
            vendorGuideline: unit.vendorGuideline && Number(unit.vendorGuideline) > 0 ? Number(unit.vendorGuideline) : null,
            northDimension: unit.northDimension?.toString().trim() || null,
            eastDimension: unit.eastDimension?.toString().trim() || null,
            westDimension: unit.westDimension?.toString().trim() || null,
            southDimension: unit.southDimension?.toString().trim() || null,
            roadFacing: unit.roadFacingSide?.name?.trim() || unit.roadFacing?.trim() || null,
            roadWidth: unit.roadWidth?.toString().trim() || null,
            registrationCharge: unit.registrationCharge && Number(unit.registrationCharge) > 0 ? Number(unit.registrationCharge) : null,
            preferredLocationCharge: unit.preferredLocationCharge && Number(unit.preferredLocationCharge) > 0 ? Number(unit.preferredLocationCharge) : null,
            unitStatusId: availableId,
            createdBy: userUid,
            modifiedBy: userUid,
            notes: unit.notes?.trim() || null,
            propertyId: createdPropertyId,
          })),
        };

        const response = await ProspectPropertyService.createUnits(createUnitsPayload);
        if (response.status === 200 || response.status === 201) {
          newUnitsSaved = true;
        }
      }

      if (existingUnits.length > 0) {
        const updateUnitsPayload = {
          propertyId: createdPropertyId,
          propertyType: propertyTypeName || propertyInfo.propertyTypeName || "",
          unitsData: existingUnits.map((unit, index) => ({
            docId: unit.id,
            order: unit.order || index + 1,
            unitNo: unit.unitNo?.trim() || null,
            sqft: unit.sqft && Number(unit.sqft) > 0 ? Number(unit.sqft) : null,
            ratePerSqft: unit.ratePerSqft && Number(unit.ratePerSqft) > 0 ? Number(unit.ratePerSqft) : null,
            governmentGuideline: unit.governmentGuideline && Number(unit.governmentGuideline) > 0 ? Number(unit.governmentGuideline) : null,
            vendorGuideline: unit.vendorGuideline && Number(unit.vendorGuideline) > 0 ? Number(unit.vendorGuideline) : null,
            northDimension: unit.northDimension?.toString().trim() || null,
            eastDimension: unit.eastDimension?.toString().trim() || null,
            westDimension: unit.westDimension?.toString().trim() || null,
            southDimension: unit.southDimension?.toString().trim() || null,
            roadFacing: unit.roadFacingSide?.name?.trim() || unit.roadFacing?.trim() || null,
            roadWidth: unit.roadWidth?.toString().trim() || null,
            registrationCharge: unit.registrationCharge && Number(unit.registrationCharge) > 0 ? Number(unit.registrationCharge) : null,
            preferredLocationCharge: unit.preferredLocationCharge && Number(unit.preferredLocationCharge) > 0 ? Number(unit.preferredLocationCharge) : null,
            modifiedBy: userUid,
            notes: unit.notes?.trim() || null,
            propertyId: createdPropertyId,
          })),
        };

        const response = await ProspectPropertyService.updateUnitById(updateUnitsPayload);
        if (response.status === 200 || response.status === 201) {
          existingUnitsUpdated = true;
        }
      }

      if (!newUnitsSaved && !existingUnitsUpdated) {
        showErrorToast("No units to save or update");
      } else {
        showSuccessToast("Units updated and/or created successfully");
      }

      await fetchGetUnitsByPropertyId(createdPropertyId);
    } catch (error) {
      console.error("Error saving units:", error);
      showErrorToast(error.response?.data?.message || "Failed to save units. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const propertyInfoValidation = () => {
    if (!propertyInfo.name?.trim()) {
      showErrorToast("Property Name is required");
      return false;
    }
    if (!propertyInfo.overAllAreaSqft && !propertyInfo.overAllAreaCent && !propertyInfo.overAllAreaGround && !propertyInfo.overAllAreaAcres) {
      showErrorToast("At least one rate field is required (Acres, Ground, Cent, or Sqft)");
      return false;
    }
   
    if(!propertyInfo.propertyEnteredDate?.trim()){
      showErrorToast("Property Entered Date is required");
      return false;
    }
   
    if (!propertyInfo.location?.value) {
      showErrorToast("Location is required");
      return false;
    }
// if(!propertyInfo.geoLocation?.trim()){
//       showErrorToast("Type Latitude and longitude is required");
//       return false;
//     }
    if (!propertyInfo.primarySourcedBy?.trim()) {
      showErrorToast("Primary Sourced By is required");
      return false;
    }
    
    if (!propertyInfo.marketingRatePer)
      {
      showErrorToast("Marketing Rate Per is required");
      return false;
    }
    if (!propertyInfo.marketingRatePerValue) {
      showErrorToast("Marketing Rate Value is required when Marketing Rate Per is provided");
      return false;
    } 
    if (!propertyInfo.vendorRatePer) {
      showErrorToast("Vendor Rate Per is required");
      return false;
    }
    if (!propertyInfo.vendorRatePerValue) {
      showErrorToast("Vendor Rate Value is required when Vendor Rate Per is provided");
      return false;
    }
      
      
    
  
    
    return true;
  };

  const handleNextStep = () => {
    const isValid = propertyInfoValidation();
    if (!isValid) return;
    if (currentStep === 1) {
      if (!createdPropertyId) {
        setShowConfirmModal(true); 
      } else {
        handleSaveOrUpdateProperty();
      }
    } else if (currentStep === 2) {
      handleSaveUnits();
    }
  };

  const confirmNextStep = async () => {
    setShowConfirmModal(false);
    setIsAssignModalOpen(true); 
  };

  const steps = [
    { id: 1, label: "Basic Info", action: () => setCurrentStep(1) ,  validation: propertyInfoValidation },
    { id: 2, label: "Unit Info", action: () => setCurrentStep(2) },
  ];

  return (
    <div className="bg-appGrayBackground min-h-screen pb-14">
      <Header />
      <ToastContainer />
      <div className="pt-28 px-6 pb-10">
        <div className="flex items-center justify-between mb-5">
          <CustomHeading
            title={
              <>
                {propertyName ? `${propertyName}` : "Add New Property"}
                <span className="text-blue-500 text-lg">{propertyStage && ` (${propertyStage})`}</span>
              </>
            }
            isIcon={true}
            textColor={"primary"}
          />
          <div className="flex gap-3">
            <CustomButton
              label={currentStep === 1 ? "Save & Next" : currentStep === 2 ? "Save Units & Next" : "Complete"}
              onClick={handleNextStep}
              isDisabled={loading}
              customStyles="text-white bg-customGreen px-6 py-3 rounded-lg hover:bg-green-600"
            />
          </div>
        </div>
        <div className="bg-white rounded-[10px] py-6 px-3 relative">
          <PropertyStepProgress currentStep={currentStep} variant={createdPropertyId ? "edit" : "create"} steps={steps} />
          {currentStep === 1 && (
            <div className="p-6">
              <ProspectPropertyInfoBasic
                propertyInfo={propertyInfo}
                setPropertyInfo={setPropertyInfo}
                handlePropertyInfoChange={handlePropertyInfoChange}
                handleArrayFieldChange={handleArrayFieldChange}
                isEdit={!!createdPropertyId}
                propertyType="layout"
              />
            </div>
          )}
          {currentStep === 2 && (
            <div className="p-6">
              <ProspectLayoutUnitPage
                tableRows={units}
                onAdd={handleAddUnit}
                onEdit={handleEditUnit}
                formatINR={formatINR}
                formatINRShort={formatINRShort}
                getStatusStyles={getStatusStyles}
                propertyId={createdPropertyId}
              />
            </div>
          )}
        </div>
        <ConfirmationModal
          showModal={showConfirmModal}
          title="Confirm Non-Editable Date Fields"
          message="The following date fields cannot be edited after property creation. Please verify their accuracy."
          content={
            <div className="space-y-2">
               { propertyInfo.propertyEnteredDate && (
                              <p className="text-sm text-gray-600">
                              Property Entered Date: {formatToIndianDate(propertyInfo.propertyEnteredDate) || "N/A"}
                            </p>  
                            )}
                            
                            {propertyInfo.docReceivedDate && (
                              <p className="text-sm text-gray-600">
                              Document Received Date: {formatToIndianDate(propertyInfo.docReceivedDate) || "N/A"}
                            </p>  
                            )}
                            {propertyInfo.fullSetOfDocReceivedDate && (
                              <p className="text-sm text-gray-600">
                              Full Set of Documents Received Date: {formatToIndianDate(propertyInfo.fullSetOfDocReceivedDate) || "N/A"}
                            </p>    
                            )}
                            {propertyInfo.propertyTimeDurationStartDate && (
                              <p className="text-sm text-gray-600">
                              Property Time Duration Start Date: {formatToIndianDate(propertyInfo.propertyTimeDurationStartDate) || "N/A"}
                            </p>  
                            )}
                            {propertyInfo.propertyTimeDurationEndDate && (
                              <p className="text-sm text-gray-600">
                              Property Time Duration End Date: {formatToIndianDate(propertyInfo.propertyTimeDurationEndDate) || "N/A"}
                            </p>  
                            )}
            </div>
          }
          onConfirm={confirmNextStep}
          onCancel={() => setShowConfirmModal(false)}
        />
        <CustomModal
          isOpen={isAssignModalOpen}
          isClose={() => setIsAssignModalOpen(false)}
          title="Assign Backend User"
          content={
            <div className="p-4 flex gap-6 items-center">
              <label className="block text-nowrap font-medium text-gray-700">Select User:</label>
              <CustomSelect
                options={sourceBy}
                value={selectedAssignUser}
                onChange={(selectedOption) => setSelectedAssignUser(selectedOption)}
                placeholder="Select User"
                 
              />
            </div>
          }
          onConfirm={async () => {
            if (!selectedAssignUser) {
              showErrorToast("Please select a user to assign");
              return;
            }
            setIsAssignLoading(true);
            await handleSaveOrUpdateProperty();
            setIsAssignModalOpen(false);
            setIsAssignLoading(false);
          }}
          className="w-60"
          loading={isAssignLoading}
          onConfirmText={"Assign"}
        />
      </div>
    </div>
  );
};

export default ProspectLayoutPage;